import { useIntercom } from "react-use-intercom";

import PrimaryButton from "../../../Components/Buttons/primary-button";

import { useModalContext } from "../../../Contexts/ModalContext";

import { modalVariants } from "../../../Utils/constants";

export default function renderStakeCheckingClosedForNonCompliance(modalContext) {
  const { updateModalComponent, setModalVariant, setModalTitle, setModalClassName } = modalContext;

  updateModalComponent(StakeCheckingClosedForNonCompliance);
  setModalVariant(modalVariants.flexDialog);
  setModalClassName("no-full-screen");
  setModalTitle("⚠️ Stake Checking: Ineligible");
}

const StakeCheckingClosedForNonCompliance = () => {
  const { show: showIntercom } = useIntercom();

  const { onModalClose } = useModalContext();

  const openSupport = () => {
    showIntercom();
    onModalClose();
  };

  return (
    <>
      <div className="modal-dialog-content">
        <p className="text-base-regular color--mist mb-3">
          You are ineligible for a Stake Checking account at this time. Your previous Stake Checking account was
          permanently closed after we couldn’t collect the{" "}
          <span className="text-base-medium">$10 Stake Saver Membership</span> Fee due to insufficient funds within 60
          days.
        </p>
        <p className="text-base-regular color--mist mb-3">
          You’ll still have full access to your Stake Wallet and rewards—but Stake Checking is no longer active.
        </p>
        <p className="text-base-regular color--mist mb-3">
          You can reapply for Stake Checking after a 3-month waiting period if you'd like to open a new account.
        </p>
        <p className="text-base-regular color--mist mb-0">
          If you believe this was a mistake or have any questions, feel free to contact our support team.{" "}
        </p>
      </div>
      <div className="action-container split-equally">
        <PrimaryButton onClick={openSupport}>Contact Support</PrimaryButton>
        <PrimaryButton className="secondary-colors" onClick={onModalClose}>
          Close
        </PrimaryButton>
      </div>
    </>
  );
};
